import React from 'react';
import PropTypes from 'prop-types';

import {
  bestMatchSort,
  highestPriceSort,
  lowestPriceSort,
  discountSort,
  commissionSort,
  lowestCommissionSort,
} from '../../defines';

export default function SearchSortSelect(props) {
  const {
    id,
    defaultDisabled,
    defaultSortText,
    forAffiliate,
    sortOrder,
    onChange,
  } = props;

  const options = [
    <option key="default" value={bestMatchSort} disabled={defaultDisabled}>{defaultSortText}</option>,
    <option key="percent_off" value={discountSort}>% Off</option>,
    <option key="price_high_low" value={highestPriceSort}>Price High - Low</option>,
    <option key="price_low_high" value={lowestPriceSort}>Price Low - High</option>,
    <option key="best_match" value={bestMatchSort}>Best Match</option>,
  ];

  if (forAffiliate) {
    options.push(
      <option key="commissionHigh" value={commissionSort}>Commission High - Low</option>
    );
    options.push(
      <option key="commissionLow" value={lowestCommissionSort}>Commission Low - High</option>
    );
  }

  return (
    <select
      id={id}
      className="snapgadget-sort-order"
      value={sortOrder}
      onChange={(e) => { onChange(e.target.value); }}
    >
      {options}
    </select>
  );
}

SearchSortSelect.propTypes = {
  id: PropTypes.string,
  defaultDisabled: PropTypes.bool,
  defaultSortText: PropTypes.string,
  forAffiliate: PropTypes.bool,
  sortOrder: PropTypes.string,
  onChange: PropTypes.func,
};
